var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqualHousing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98,41.45L49.86,13,1.72,41.38v9.3H7.96v33.1H91.76V50.74h6.24v-9.29ZM14.09,77.65V41.2L49.86,20.12l35.77,21.14v36.39H14.09Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.03,
    y: 44.61,
    width: 31.5,
    height: 6.13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.03,
    y: 59.21,
    width: 31.5,
    height: 6.13
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualHousing);
export default __webpack_public_path__ + "static/media/equal-housing.a1806c02f277dab96a0e3749518865c1.svg";
export { ForwardRef as ReactComponent };